import { apiSahClassifications } from '~constants/api';

import { get, post, put } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

export const typePrefix = 'sah-client-classifications';

const config = [
  { actionType: 'getAll', apiPath: `${apiSahClassifications}`, method: get },
  { actionType: 'create', apiPath: `${apiSahClassifications}`, method: post },
  {
    actionType: 'getOne',
    apiPath: (params: Params) => `${apiSahClassifications}/${params.id}`,
    method: get,
  },
  {
    actionType: 'update',
    apiPath: (params: Params) => `${apiSahClassifications}/${params.id}`,
    method: put,
  },

  {
    actionType: 'uploadFile',
    apiPath: `${apiSahClassifications}/upload`,
    method: post,
    isUpload: true,
  },
];

export const { getAll, getOne, create, update, uploadFile } = createThunks(typePrefix, config);
